import { render, staticRenderFns } from "./v-gain-a.vue?vue&type=template&id=0f05b9bb&"
import script from "./v-gain-a.vue?vue&type=script&lang=js&"
export * from "./v-gain-a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports